import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { CHAT_CONVERSATION_CREATE } from "./gql";

const useChatConversationCreate = createDefaultMutationHook(CHAT_CONVERSATION_CREATE);

export default useChatConversationCreate;
